import React, { createContext, useContext, useEffect, useState } from 'react';
import { styles } from '../../styles';
import { Flex, HStack, useBreakpointValue, useTheme } from '@chakra-ui/react';
import { DropdownCustom } from '../dropdownCustom/dropdownCustom';
import { Link } from 'react-router-dom';
import { useAppContext } from '../../../../App';

export const DROP_NAMES = Object.freeze({
    cursos: 'cursos',
    diploma: 'diplomados',
    secretariados: 'secretariados'
});

const NavbarContext = createContext();
export const useNavbarContext = () => {
  return useContext(NavbarContext)
}

export const resetStepOpen = {
  cursos: false,
  diplomados: false,
  secretariados: false
}

export const COURSES_TYPES = {
  cursos: "Cursos",
  diploma: "Trayecto Profesional",
  secretary: "Secretariados"
}

export default function Navbar({hasLeavedHeader}) {
  const {categoryItems = [], diploma = [], secretarys, setAppType} = useAppContext();
  const [stepOpen, setStepOpen] = useState({});
  const theme = useTheme();
  const style = styles(theme);

  const handleToggleMenu = (tag) => {
    setStepOpen({...resetStepOpen, [tag]: !resetStepOpen[tag]});
  }
  
  const value = {stepOpen, setStepOpen, handleToggleMenu}
  const display = useBreakpointValue({ base: "none", md: "flex" });

  if(!categoryItems) return null;
  
  return (
    <NavbarContext.Provider value={value} >
      <Flex alignItems="center" justifyContent="space-between">
        <HStack as="nav" display={display} className="sansation-bold" >
          <ul style={style.container}>
            <DropdownCustom items={categoryItems} route={COURSES_TYPES.cursos} dropName={DROP_NAMES.cursos}/>
            <p style={style.separator}>|</p>
            <DropdownCustom items={diploma} route={COURSES_TYPES.diploma} dropName={DROP_NAMES.diploma}/>
            <p style={style.separator}>|</p>
            <DropdownCustom items={secretarys} route={COURSES_TYPES.secretary} dropName={DROP_NAMES.secretariados}/>
            <p style={style.separator}>|</p>
            <li style={style.tagMenu} onMouseOver={() =>{ setStepOpen(resetStepOpen); setAppType('Cursos')}}>
              <Link to={'/in-company'}>
                EMPRESAS
              </Link>
            </li>
            <p style={style.separator}>|</p>
            <li style={style.tagMenu} onMouseOver={() =>{ setStepOpen(resetStepOpen); setAppType('Cursos')}}>
              <Link to={'/comunidad'}>
                COMUNIDAD
              </Link>
            </li>
            <p style={style.separator}>|</p>
            <li style={style.tagMenu} onMouseOver={() =>{ setStepOpen(resetStepOpen); setAppType('Cursos')}}>
              <Link to={'/sobre-nosotros'}>
                SOBRE NOSOTROS
              </Link>
            </li>
          </ul>
        </HStack>
      </Flex>
    </NavbarContext.Provider>
  );
}
